module.exports = __webpack_public_path__ + "yout.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/yout.png
// module id = 537
// module chunks = 0